<template>
  <UiModal
    :title="$t('PUBLICATION.CREATE_MODAL.TITLE')"
    :btn-ok-label="$t('ACTION.CONFIRM')"
    :loading="loading"
    :btn-ok-disabled="loading"
    max-width="900px"
    @okAction="agreeAction"
    @cancelAction="disagreeAction"
  >
    <UiTextarea
      :model-value="exportDetails.message"
      @update:modelValue="exportDetails.message = String($event ?? '')"
      :rows="15"
      no-resize
      :label="$t('PUBLICATION.CREATE_MODAL.COMMENT')"
      :placeholder="$t('PUBLICATION.CREATE_MODAL.COMMENT_PLACEHOLDER')"
      class="w-full"
    />
  </UiModal>
</template>

<script setup lang="ts">
import { reactive, ref } from 'vue'

import UiModal from '@/shared/components/ui/UiModal.vue'
import UiTextarea from '@/shared/components/ui/UiTextarea.vue'

import { useWarningBannerStore } from '../../shared/store/warningBanner.store'
import { PublicationsService } from './publications.service'
import { usePublicationsStore } from './publications.store'

const emit = defineEmits<(e: 'refresh-data') => void>()

const exportDetails = reactive({
  message: '',
})
const loading = ref(false)

async function updateBanner() {
  await useWarningBannerStore.getState().loadWarningBanner()
}

async function agreeAction() {
  if (loading.value) return
  loading.value = true
  usePublicationsStore.getState().setExportPending(true)
  try {
    await PublicationsService.doPublication(exportDetails)
    emit('refresh-data')
    usePublicationsStore.getState().hidePublicationModalAction()
    setTimeout(updateBanner, 2000)
  } catch {
    // the service already notifies the failure
    usePublicationsStore.getState().setExportPending(false)
  } finally {
    loading.value = false
  }
}

function disagreeAction() {
  usePublicationsStore.getState().hidePublicationModalAction()
}
</script>
